<template>
  <div style="width: 100%">
    <div
      class="styled-radio-container styled-radio-container--ou-donation row"
      v-if="!onlyMonthly"
      :class="{ 'styled-radio-container--ou-reveresd': defaultMonthly }"
    >
      <div class="radio-part">
        <input
          id="oneTime"
          type="radio"
          class="frequency"
          :checked="type == 'single'"
          @click="setSingle"
        />
        <FormLabel for="oneTime">{{ oneTimeText }}</FormLabel>
      </div>
      <div class="radio-part" v-if="addMonthly">
        <input
          id="monthly"
          type="radio"
          class="frequency"
          :checked="type == 'monthly'"
          @click="setMonthly"
        />
        <FormLabel for="monthly">{{ monthlyText }}</FormLabel>
      </div>
      <div class="radio-part" v-if="addSplit && form.gateway !== 'CardCom-ouisrael-donations'">
        <input
          id="split"
          type="radio"
          class="frequency"
          :checked="type == 'split'"
          @click="setSplit"
        />
        <FormLabel for="split">{{ splitText }}</FormLabel>
      </div>
    </div>
    <div class="monthly-note" v-if="type === 'split'">
      <select :value="duration" @change="(e) => setValue('periodMonths', e.target.value)">
        <option v-for="i in splitMonths" :key="i" :value="i">
          {{ i }} {{ i == 1 ? "Month" : "Months" }}
        </option>
      </select>
      <div v-if="splitAmount">
        {{ splitAmount }}
      </div>
      <div v-else>Please select amount to split, and number of months</div>
    </div>
    <div class="monthly-note" v-if="type === 'monthly'">
      <div v-if="lang == 'esp'">
        Tu donación se realizará hoy y el <strong>{{ monthDay }}</strong> de cada mes
        siguiente mediante el método de pago seleccionado. Puede cambiar o cancelar esta
        cantidad en cualquier momento.
      </div>
      <div v-else>
        Your donation will be made today and on the <strong>{{ monthDay }}</strong> of
        each following month using the payment method selected. You may change or cancel
        this amount at any time.
      </div>
    </div>
    <br />
  </div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  type PropType,
  ref,
  watch,
  onMounted,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

function round(number: number) {
  return Math.floor(number * 100) / 100;
}
export default defineComponent({  props: {
    addSplit: {
      type: Boolean,
      default: false,
    },
    defaultMonthly: {
      type: Boolean,
      default: false,
    },
    splitMonths: {
      type: Number,
      default: 12,
    },
    addMonthly: {
      type: Boolean,
      default: false,
    },
    onlyMonthly: {
      type: Boolean,
      default: false,
    },
    monthlyText: {
      type: String,
      default: "Monthly",
    },
    splitText: {
      type: String,
      default: "Split Payment",
    },
    oneTimeText: {
      type: String,
      default: "One time",
    },
    lang: {
      type: String,
    },
  },
  setup(props) {
    const { form, setValue } = usePaymentForm();

    const type = ref<"single" | "monthly" | "split">("single");

    const splitAmount = computed(() => {
      if (!form.value.amount) return;

      const recurringAmount = Math.round(
        Number(form.value.amount) / Number(form.value.periodMonths)
      );

      const totalAmount = recurringAmount * +form.value.periodMonths!;

      var difference = Number(form.value.amount) - totalAmount;

      var initialAmount = recurringAmount + difference;

      if (initialAmount !== recurringAmount) {
        return `One payment of ${form.value.currency === "ILS" ? "₪" : "$"}${Math.round(initialAmount)} and ${+form.value.periodMonths! - 1} payments of ${form.value.currency === "ILS" ? "₪" : "$"}${Math.round(recurringAmount)}`;
      } else {
        return `${form.value.periodMonths} payments of ${form.value.currency === "ILS" ? "₪" : "$"}${Math.round(recurringAmount)}`;
      }
    });

    onMounted(() => {
      if (props.onlyMonthly) {
        type.value = "monthly";
        setValue("dayOfMonth", "" + new Date().getDate());
        setValue("periodMonths", null);
      }
      if (props.defaultMonthly) {
        type.value = "monthly";
        setValue("dayOfMonth", "" + new Date().getDate());
        setValue("periodMonths", null);
      }
    });

    function setSingle() {
      type.value = "single";
      setValue("dayOfMonth", null);
      setValue("periodMonths", null);
    }

    function setMonthly() {
      type.value = "monthly";
      setValue("dayOfMonth", "" + new Date().getDate());
      setValue("periodMonths", null);
    }

    function setSplit() {
      type.value = "split";
      setValue("dayOfMonth", null);
      setValue("periodMonths", "2");
    }

    return {
      duration: computed(() => form.value.periodMonths),
      setSplit,
      setSingle,
      setMonthly,
      setValue,
      type,
      form,
      splitAmount,
      monthDay: computed(() => {
        const i = +form.value.dayOfMonth!;

        const j = i % 10,
          k = i % 100;
        if (j == 1 && k != 11) {
          return i + "st";
        }
        if (j == 2 && k != 12) {
          return i + "nd";
        }
        if (j == 3 && k != 13) {
          return i + "rd";
        }
        return i + "th";
      }),
    };
  },
});
</script>
<style scoped lang="scss">
.monthly-note {
  font-size: 13px;
  line-height: 1.4;
  margin-top: 10px;
  display: flex;
  align-items: center;
  select {
    max-width: calc(22% - 10px);
    margin-right: 10px;
    min-width: 120px;
  }
}

.styled-radio-container.styled-radio-container--ou-donation.row.styled-radio-container--ou-reveresd {
  flex-flow: row-reverse;
  justify-content: flex-end;
}
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 22%;
      flex: 1;
      padding-right: 10px;
      padding-left: 0;
      max-width: 22%;
      margin-bottom: 10px;
    }
  }
  input[type="radio"] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type="radio"]:checked + label {
    background: $color-blue;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
}
</style>
